import { GoMakeDialog } from "@/components";
import { CircleCheckbox } from "@/components/check-box/circle-check-box";
import { Checkbox, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyle } from "../style";
import { UpdateTypes } from "./section-mapping";
import { CheckboxIcon } from "@/icons";
import { CheckboxCheckedIcon } from "@/icons";
import { useGomakeTheme } from "@/hooks/use-gomake-thme";

interface UpdateParameterModalProps {
  openModal: boolean;
  onClose: () => void;
  onUpdate: any;
  selectedUpdateType: UpdateTypes | null;
  setSelectedUpdateType: any;
  hideDoNotAskBox?: boolean;
  setDoNotAskNextTime?: any;
  doNotAskNextTime?: boolean;
  showThirdOption?: boolean;
  isLoading?: boolean;
}

const UpdateParameterModal = ({
  openModal,
  onClose,
  onUpdate,
  selectedUpdateType,
  setSelectedUpdateType,
  hideDoNotAskBox = false,
  showThirdOption = false,

  setDoNotAskNextTime,
  doNotAskNextTime,
  isLoading = false,
}: UpdateParameterModalProps) => {
  const { t } = useTranslation();
  const { classes } = useStyle();
  const { primaryColor } = useGomakeTheme();
  return (
    <GoMakeDialog
      open={openModal}
      title={t("products.parameters.updateParameterModalTitle")}
      onClose={onClose}
      onPrimaryAction={onUpdate}
      primaryButtonLabel={t("modal.update")}
      cancelButtonLabel={t("modal.cancel")}
      primaryButtonLoading={isLoading}
      primaryButtonDisabled={selectedUpdateType === null || isLoading}
      cancelButtonDisabled={isLoading}
      maxWidth="sm"
      fullWidth
      customStyles={{
        paper: classes.insideStyle,
      }}
    >
        <Stack direction={"column"} gap={"5px"} paddingBottom={"20px"}>
          <Stack direction={"row"} width={"100%"} alignItems={"center"}>
            <CircleCheckbox
              checked={selectedUpdateType === UpdateTypes.PRODUCT_ONLY}
              onChange={() => setSelectedUpdateType(UpdateTypes.PRODUCT_ONLY)}
              color={primaryColor(500)}
            />
            <span style={classes.optionsTitle}>
              {t("products.parameters.productOnly")}
            </span>
          </Stack>
          <Stack direction={"row"} width={"100%"} alignItems={"center"}>
            <CircleCheckbox
              checked={selectedUpdateType === UpdateTypes.SAME_PRICING_TYPE}
              onChange={() =>
                setSelectedUpdateType(UpdateTypes.SAME_PRICING_TYPE)
              }
              color={primaryColor(500)}
            />
            <span style={classes.optionsTitle}>
              {t("products.parameters.samePricingType")}
            </span>
          </Stack>
          {showThirdOption && (
            <Stack direction={"row"} width={"100%"} alignItems={"center"}>
              <CircleCheckbox
                checked={selectedUpdateType === UpdateTypes.ALL_PRODUCTS}
                onChange={() => setSelectedUpdateType(UpdateTypes.ALL_PRODUCTS)}
                color={primaryColor(500)}
              />
              <span style={classes.optionsTitle}>
                {t("products.parameters.allProducts")}
              </span>
            </Stack>
          )}
        </Stack>
        {!hideDoNotAskBox && (
          <>
            <Checkbox
              checked={doNotAskNextTime}
              onChange={() => setDoNotAskNextTime(!doNotAskNextTime)}
              icon={<CheckboxIcon />}
              checkedIcon={<CheckboxCheckedIcon />}
              disabled={selectedUpdateType === null}
            />
            <span style={classes.doNotAskNextTime}>
              {t("products.parameters.dontAskNextTime")}
            </span>
          </>
        )}
    </GoMakeDialog>
  );
};
export { UpdateParameterModal };
